var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState } from "react";
export var useAccordion = function (initialStatus) {
    var _a = useState(initialStatus), accordionStatus = _a[0], setAccordionStatus = _a[1];
    var toggleAccordion = function (section) {
        setAccordionStatus(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[section] = !prev[section], _a)));
        });
    };
    return { accordionStatus: accordionStatus, toggleAccordion: toggleAccordion };
};
